import { Roles } from "../../../constants/roles";
import { FormBase } from "../../form-base-form";

class ImageForm extends FormBase {
    public getContainer(postKey: string, root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.IMAGE_MANAGER}"][data-post-id="${postKey}"]`, HTMLElement);
    }

    public getRemovedAttachedImagesInput(root: ParentNode): HTMLInputElement | null {
        return this.getInput(root, 'input[name="removed_attached_images"]');
    }

    public getRemoveButtons(root: ParentNode): HTMLButtonElement[] {
        return this.queryElements(root, `[data-role="${Roles.MEDIA_REMOVE}"]`, HTMLButtonElement);
    }

    public getFileInput(root: ParentNode): HTMLInputElement | null {
        return this.queryElement(
            root,
            `[data-role="${Roles.IMAGE_UPLOAD}"], input[type="file"][name="images[]"]`,
            HTMLInputElement,
        );
    }

    public getAddButton(root: ParentNode): HTMLButtonElement | null {
        return this.getButton(root, `[data-role="${Roles.PICKER_ADD}"]`);
    }

    public getImageGrid(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.IMAGE_GRID}"]`, HTMLElement);
    }

    public getDropHint(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, ".image-drop-hint", HTMLElement);
    }

    public getEventInput(event: Event): HTMLInputElement | null {
        return this.fromEventTarget(event, HTMLInputElement);
    }

    public getEventTarget(event: Event): HTMLElement | null {
        return this.fromEventTarget(event, HTMLElement);
    }

    public getClosestRotateTrigger(element: Element | null | undefined): HTMLElement | null {
        return this.closest(element, `[data-role="${Roles.MEDIA_ROTATE}"]`, HTMLElement);
    }

    public getClosestRemoveTrigger(element: Element | null | undefined): HTMLElement | null {
        return this.closest(element, `[data-role="${Roles.MEDIA_REMOVE}"]`, HTMLElement);
    }

    public getExistingImageTile(element: Element | null | undefined): HTMLElement | null {
        return this.closest(element, '[data-image-type="existing"]', HTMLElement);
    }

    public getNewImageTile(element: Element | null | undefined): HTMLElement | null {
        return this.closest(element, '[data-image-type="new"]', HTMLElement);
    }

    public getExistingImageItemTile(element: Element | null | undefined): HTMLElement | null {
        return this.closest(element, `[data-item-role="${Roles.EXISTING_IMAGE_TILE}"]`, HTMLElement);
    }

    public getMediaTile(element: Element | null | undefined): HTMLElement | null {
        return this.closest(element, `[data-role="${Roles.MEDIA_TILE}"]`, HTMLElement);
    }

    public getImage(root: ParentNode): HTMLImageElement | null {
        return this.queryElement(root, "img", HTMLImageElement);
    }

    public getExistingImageTiles(root: ParentNode): HTMLElement[] {
        return this.queryElements(
            root,
            `[data-item-role="${Roles.EXISTING_IMAGE_TILE}"][data-image-type="existing"]`,
            HTMLElement,
        );
    }

    public getLoadingText(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, ".loading-text", HTMLElement);
    }

    public getRemovedIndicator(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.MEDIA_REMOVED_INDICATOR}"]`, HTMLElement);
    }

    public getMediaControls(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.MEDIA_CONTROLS}"]`, HTMLElement);
    }
}

const imageForm = new ImageForm();

export { ImageForm, imageForm };
